import axios from "axios";
import { KYC_TOKEN, ROOT_URL } from "./endpoints";
import { ApiErrors } from "../constants/ApiErrors";
export const fetchKycToken = async (token: string): Promise<string> => {
  try {
    const response = await axios.get<string>(`${ROOT_URL}${KYC_TOKEN}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response && response.data) {
      return response.data;
    }
    return ApiErrors.NoResponseData;
  } catch (e) {
    return ApiErrors.NoResponseData;
  }
};
